"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewAcceptBanner = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./PreviewAccept.css"));
var PreviewAcceptBanner = function (_a) {
    var useExtraSpacing = _a.useExtraSpacing;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.container({ extraSpacing: useExtraSpacing || false }) },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.banner, align: "center", direction: "horizontal", padding: "m", gap: "s" },
            react_1.default.createElement(icons_1.Preview, { size: icons_1.IconSize.Small }),
            react_1.default.createElement(kaleidoscope_1.Label, { size: "s", className: styles.label }, "Preview accept mode"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Click on the title to auto-fill"),
            react_1.default.createElement(kaleidoscope_2.Tooltip, { size: kaleidoscope_2.TooltipSize.Large, content: "This is a preview of how your client will accept the page. Entering data here won't count as actually accepting the page" },
                react_1.default.createElement(icons_1.Help, { size: icons_1.IconSize.Small })))));
};
exports.PreviewAcceptBanner = PreviewAcceptBanner;
var ResetPreviewAcceptButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement(kaleidoscope_1.Button, { className: "inline-preview-accept__reset-button", type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: onClick },
        react_1.default.createElement(icons_1.Retry, null),
        "Reset preview accept"));
};
exports.default = ResetPreviewAcceptButton;
